import CoursewareItemProvider from 'services/coursewareItem/CoursewareItemProvider';
import HistoryProvider from './history/HistoryProvider';
import CoursewareTargetProvider from './coursewareTarget/CoursewareTargetProvider';

const moveOnSubscriptions = {};

export default class DeprecatedResourceService {
  constructor({ id }) {
    this.id = id;
  }

  async moveOn() {
    const { type, ancestry } = await CoursewareTargetProvider.getCoursewareTypeAndAncestry(this.id);

    let activityIds;
    if (type === 'ACTIVITY') {
      activityIds = [this.id];
    } else {
      activityIds = ancestry.filter(({ elementType }) => elementType === 'ACTIVITY').map(({ elementId }) => elementId);
    }

    await CoursewareItemProvider.refreshProgressAndScore(activityIds[0]);

    if (moveOnSubscriptions[this.id]) {
      const moveOnOccurred = true;
      moveOnSubscriptions[this.id].notify(moveOnOccurred);
    }

    // "moveOn" will impact the history, so make sure to notify subscribers
    activityIds.forEach((elementId) => HistoryProvider.notifySubscribers(elementId));
  }

  subscribeToMoveOn(targetId, notify) {
    const subscription = {
      id: targetId, // We don't allow multiple subscriptions (not perfect) so this is okay.
      notify,
    };
    moveOnSubscriptions[subscription.id] = subscription;
  }

  unsubscribeFromMoveOn(subscription) {
    delete moveOnSubscriptions[subscription.id];
  }

  static build(args) {
    return new DeprecatedResourceService(args);
  }
}
